"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertfanAlertsApi = exports.AlertfanAlertsApiFactory = exports.AlertfanAlertsApiFp = exports.AlertfanAlertsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * AlertfanAlertsApi - axios parameter creator
 * @export
 */
const AlertfanAlertsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearAlerts: (requestBody_1, ...args_1) => __awaiter(this, [requestBody_1, ...args_1], void 0, function* (requestBody, options = {}) {
            const localVarPath = `/alertfan/alerts/clear`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts: (...args_2) => __awaiter(this, [...args_2], void 0, function* (options = {}) {
            const localVarPath = `/alertfan/alerts`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isActive: (requestBody_2, ...args_3) => __awaiter(this, [requestBody_2, ...args_3], void 0, function* (requestBody, options = {}) {
            const localVarPath = `/alertfan/alerts/isActive`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.AlertfanAlertsApiAxiosParamCreator = AlertfanAlertsApiAxiosParamCreator;
/**
 * AlertfanAlertsApi - functional programming interface
 * @export
 */
const AlertfanAlertsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.AlertfanAlertsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearAlerts(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.clearAlerts(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AlertfanAlertsApi.clearAlerts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.getAlerts(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AlertfanAlertsApi.getAlerts']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {Array<any>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isActive(requestBody, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.isActive(requestBody, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AlertfanAlertsApi.isActive']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.AlertfanAlertsApiFp = AlertfanAlertsApiFp;
/**
 * AlertfanAlertsApi - factory interface
 * @export
 */
const AlertfanAlertsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.AlertfanAlertsApiFp)(configuration);
    return {
        /**
         *
         * @param {AlertfanAlertsApiClearAlertsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        clearAlerts(requestParameters = {}, options) {
            return localVarFp.clearAlerts(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAlerts(options) {
            return localVarFp.getAlerts(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {AlertfanAlertsApiIsActiveRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isActive(requestParameters = {}, options) {
            return localVarFp.isActive(requestParameters.requestBody, options).then((request) => request(axios, basePath));
        },
    };
};
exports.AlertfanAlertsApiFactory = AlertfanAlertsApiFactory;
/**
 * AlertfanAlertsApi - object-oriented interface
 * @export
 * @class AlertfanAlertsApi
 * @extends {BaseAPI}
 */
class AlertfanAlertsApi extends base_1.BaseAPI {
    /**
     *
     * @param {AlertfanAlertsApiClearAlertsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanAlertsApi
     */
    clearAlerts(requestParameters = {}, options) {
        return (0, exports.AlertfanAlertsApiFp)(this.configuration).clearAlerts(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanAlertsApi
     */
    getAlerts(options) {
        return (0, exports.AlertfanAlertsApiFp)(this.configuration).getAlerts(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {AlertfanAlertsApiIsActiveRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AlertfanAlertsApi
     */
    isActive(requestParameters = {}, options) {
        return (0, exports.AlertfanAlertsApiFp)(this.configuration).isActive(requestParameters.requestBody, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.AlertfanAlertsApi = AlertfanAlertsApi;
//# sourceMappingURL=alertfan-alerts-api.js.map